import * as React from "react";

function SvgMobile(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M11 14.2H5c-.4 0-.8-.3-.8-.8v-11c0-.4.3-.8.8-.8h6c.4 0 .8.3.8.8v11c0 .5-.4.8-.8.8zm-5.2-2h4.5v-9H5.8v9z" /></svg>;
}

export default SvgMobile;